<template>
	<div class="wrap-layer">
		<light-header :back="'/user-space/contracts?status=all'"></light-header>
		<div class="steps">
			<div class="step">
				<span class="circle">
					<i class="el-icon-check" style="color: #3699FF;font-weight: bold"></i>
				</span>
				选择套餐
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step">
				<span class="circle"><i class="el-icon-check" style="color: #3699FF;font-weight: bold"></i></span>
				在线支付
			</div>
			<i class="el-icon-arrow-right"></i>
			<div class="step active">
				<span class="circle">3</span>
				完成
			</div>
		</div>
		<div class="feedback auto">
			<img class="success-img" src="../../assets/images/cart/pay-success.png" alt="">
			<div class="tip" v-if="audit == 'yes'">
				订单提交成功，请等待审核
			</div>
			<div class="tip" v-else>
				订单支付成功
			</div>
		</div>
	</div>
</template>
<script>
	import lightHeader from "../../components/lightHeader";
	export default {
		components: {
			lightHeader
		},
		data() {
			return {
				audit: "no"
			};
		},

		created() {
			this.audit = this.$route.query.audit;
		},
		mounted() {},
		methods: {}
	};
</script>
<style lang="scss">
	.steps {
		width: 441px;
		margin: 20px auto;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.step {
			font-size: 16px;
			font-weight: 400;
			color: #333333;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.circle {
				display: block;
				width: 34px;
				height: 34px;
				border: 1px solid #dedcdb;
				border-radius: 50%;
				text-align: center;
				line-height: 34px;
				font-weight: 400;
				color: #c3c3c3;
				font-size: 16px;
				margin-right: 12px;
			}
			&.active {
				.circle {
					background: #3296fa;
					color: #fff;
				}
				color: #3699ff;
				border: none;
			}
		}
	}
</style>
<style lang="scss" scoped>
	.wrap-layer {
		background: #f0f0f5;
		height: 100vh;
		.feedback {
			background: #fff;
			padding: 150px 30px 50px;
			height: calc(100vh - 145px);
			text-align: center;
			.success-img {
				width: 200px;
				height: auto;
				display: block;
				margin: 0 auto;
			}
		}
		.tip {
			display: block;
			text-align: center;
			margin: 52px auto 0;
			font-size: 16px;
			font-weight: 400;
			color: #333333;
		}
	}
</style>
